import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../isLoading.slice';
import axios from 'axios';
import { logOut } from '../../../resources/utils';

export const configsSlice = createSlice({
    name: 'configurations',
    initialState: {
        items: [],
        item: {},
        message: "",
        error: "",
    },
    reducers: {
        initialStateConfig: (state) => {
            state.items = [];
            state.item = {};
            state.message = "";
            state.error = "";
        },
        setConfigs: (state, action) => {
            state.items = action.payload;
            state.item = {};
            state.message = "";
            state.error = "";
        },
        setConfig: (state, action) => {
            state.item = action.payload;
            state.message = "";
            state.error = "";
        },
        setConfigMessages: (state, action) => {
            state.message = action.payload;
            state.error = "";
        },
        setConfigError: (state, action) => {
            state.error = action.payload;
            state.message = "";
        },
    }
});
export const getConfigsThunk = () => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/configurations`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setConfigs(res.data));
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setConfigError(res.response?.data));
            }
        })
        .finally(() => dispatch(setIsLoading(false)));
};

export const getConfigThunk = (config_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/configurations/${config_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setConfig(res.data));
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setConfigError(res.response?.data));
            }
        })
        .finally(() => dispatch(setIsLoading(false)));
};

export const createConfigThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.post(`/configurations/createConfig`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setConfigMessages(res.data.data));
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setConfigError(res.response?.data));
            }
        })
        .finally(() => dispatch(setIsLoading(false)));
};

export const updateConfigThunk = (config_id, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/configurations/updateConfig/${config_id}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setConfigMessages(res.data.data));
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setConfigError(res.response?.data));
            }
        })
        .finally(() => dispatch(setIsLoading(false)));
};

export const chageStatePeriodsThunk = (config_id, data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/configurations/chageStatePeriods/${config_id}`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setConfigMessages(res.data.data));
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setConfigError(res.response?.data));
            }
        })
        .finally(() => dispatch(setIsLoading(false)));
};

export const deleteConfigThunk = (config_id) => dispatch => {
    dispatch(setIsLoading(true));
    axios.delete(`/configurations/${config_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setConfigMessages(res.data.data));
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setConfigError(res.response?.data));
            }
        })
        .finally(() => dispatch(setIsLoading(false)));
};


export const {
    initialStateConfig,
    setConfigs,
    setConfig,
    setConfigMessages,
    setConfigError,
} = configsSlice.actions;

export default configsSlice.reducer;
